import { memo } from "react"
import Marquee from "react-fast-marquee"
import { marqueeConfig } from "./data/marquee-config"
import { useMarqueeScroll } from "./hooks/use-marquee-scroll"
import { MarqueeMessage } from "./MarqueeMessage"

// import { LandingAudioToggle } from './LandingAudioToggle'

export const LandingMarqueeTop = memo(function LandingMarqueeTop() {
  const isScrolled = useMarqueeScroll()
  const { speed, messages, gradient, classes } = marqueeConfig

  return (
    <div className={classes.container}>
      {/* Mobile audio toggle pill */}
      {/* <LandingAudioToggle /> */}
      {/* Blurred black backdrop band that appears behind marquee on scroll */}
      <div
        className={`${classes.backdrop} ${isScrolled ? "opacity-100" : "opacity-0"}`}
        style={{
          background: gradient.background,
          filter: "blur(0px)",
        }}
      />

      <Marquee gradient={false} speed={speed} pauseOnHover={false} className="w-full h-12 bg-transparent relative z-10">
        {messages.map((message) => (
          <MarqueeMessage key={message.id} message={message} />
        ))}
      </Marquee>
    </div>
  )
})
